import { getAllEntitiesAtPath } from 'app/infrastructure/store';
import { tableName } from 'app/area/case/case-data-model';
import { getCaseData } from 'app/infrastructure/ui/renderer/resolvers';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';

/**
 * Resolves a deep-link entity path (e.g. '/TblAction/2') to the case's action
 **/
export const editActionEntityPath = (state: CaseState, uiEngineProps: ConnectedComponentProps) => {
  const actionEntities = getAllEntitiesAtPath(
    getCaseData(state, uiEngineProps),
    [tableName.trans, tableName.action]
  );

  if (actionEntities.length !== 1) {
    return { editActionEntityPath: '' };
  }

  const actionIteratorNo = actionEntities?.[0]?.id?.find(part => part?.[tableName.action] !== undefined)?.[tableName.action];

  return {
    editActionEntityPath: actionIteratorNo !== undefined ? `/${tableName.action}/${actionIteratorNo}` : ''
  };
};
